 <template>
  <v-form ref="formEditSpendType" v-model="validForm" lazy-validation>
    <v-row>      
      <v-col>
        <v-text-field 
          label="Concepto" 
          :rules="[rules.required]"
          v-model="localTipo.name"         
          ></v-text-field>        
      </v-col>
    </v-row>
    
    <v-btn @click="savetype" depressed color="#00aff2" dark>Aceptar</v-btn>    
  </v-form>
</template>
 
<script>

export default {  
  props: {
    tipo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    validForm: true,
    localTipo: {},
    rules: {
          required: (value) => !!value || 'Required.',         
          lonsm: [ (v) => !v || v.length <= 50 || 'Nombre debe ser menor a 50 caracteres' ],         
          },
  }),
  created() {
    this.localTipo = {...this.tipo};
  },
  methods: {    
    savetype() {    
      const data = {    
        id: this.localTipo.id,    
        name: this.localTipo.name,
      };
      if (this.$refs.formEditSpendType.validate()) {
        this.$emit('savetype', data);
      }
    },
  }
};
</script>